/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Not_Taken_Part_TitleInputs */



/**
* | output |
* | --- |
* | "The conversation didn’t really get going" |
*
* @param {Practice_Not_Taken_Part_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_not_taken_part_title = /** @type {((inputs?: Practice_Not_Taken_Part_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Not_Taken_Part_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Het gesprek kwam niet echt op gang")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La conversation n’a pas vraiment démarré")
	return /** @type {LocalizedString} */ ("The conversation didn’t really get going")
});